import React from 'react';
import {Text, Icon, IconType} from '@/ui-kits';
import { cn } from '@/utils/common_functions';
interface ProfileDetailSectionsProps {
  title: string;
  icon?: IconType;
  children: React.ReactNode;
  wrapperClassName?: string;
  className?: string;
}

export const ProfileDetailSections: React.FC<ProfileDetailSectionsProps> = props => {
  const {title, icon, children,wrapperClassName, className} = props;
  return (
    <div className={cn('p-3 md:p-6 flex flex-col bg-profile_feedback_bg rounded-xl border border-ui_input_border gap-4', className)}>
      <div className='flex gap-4 items-center'>
        {icon && <Icon type={icon} />}
        <Text variant='title' className='text-ui_blue'>{title}</Text>
      </div>
      <div className={wrapperClassName}>{children}</div>
    </div>
  );
};
